import React from "react";
import { AccessibleFocusOutline } from "./AccessibleFocusOutline";
import { ChevronRight } from "../common/IconsV2";

export const NextButton = ({ onClick, textOverride, variant, disabled }) => {

	const variantClasses = () => {
		switch (variant) {
			case "navigationButton":
				return "pointerCursor text-black navigation-next-button";
			case "navigationText":
				return "flex align-center items-center justify-end pointerCursor text-sm text-black text-right font-bold leading-snug";
			case "inactive":
				return "inactive-button pointerCursor";
			case "active":
				return "active-button pointerCursor";
			case "next":
				return `uppercase text-center text-white bg-app-charcoal px-3 py-2 rounded-3xl w-full text-base block ${disabled && "opacity-25"
					} pointerCursor`;

			default:
				//Previous default style
				return `uppercase text-center text-white bg-app-charcoal px-3 py-2 rounded-lg w-full text-base block ${disabled && "opacity-25"
					} pointerCursor`;
		}
	};

	return (

		<AccessibleFocusOutline classes={"w-full"}>
			{variant === "navigationText" ? (
				<div
					onClick={onClick}
					disabled={disabled}
					className={`${variantClasses()} mr-2`}
				>
					{textOverride ? textOverride : "Next"}{" "}
					<ChevronRight className={"inline-block w-3.5 ml-2.5"} />
				</div>
			) : (
				<button
					onClick={onClick}
					className={`${variantClasses()}`}
					disabled={disabled}
				>
					{textOverride ? textOverride : "Next"}
				</button>
			)}
		</AccessibleFocusOutline>
	);
};
